import { Component, OnInit, Input, Output, EventEmitter, SecurityContext } from '@angular/core';
import { IonInput, LoadingController, NavController, Platform, ToastController, AlertController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { SubscriptionListenerComponent } from 'src/app/angular-wallet-base/SubscriptionListenerComponent';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { Store } from '@ngrx/store';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MembersPortalService } from 'src/app/angular-wallet-base/services/members-portal.service';
import { TranslateService } from '@ngx-translate/core';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx';
import { Logger } from '../../angular-wallet-base/services/logger.service';
import { DocumentViewer } from '@ionic-native/document-viewer/ngx';
import { DocOperationsService } from 'src/app/angular-wallet-base/services/doc-operations.service';
import { presentAlert } from '../../angular-wallet-base/utils';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { AuthService } from 'src/app/angular-wallet-base/services/auth.service';
import { environment } from '../../../environments/environment';
import { inspect } from 'util';
@Component({
  selector: 'app-tos-contracts',
  templateUrl: './tos-contracts.component.html',
  styleUrls: ['./tos-contracts.component.scss'],
})
export class TosContractsComponent extends SubscriptionListenerComponent implements OnInit {
  @Input() tos: any;
  @Input() tosType: any;
  @Input() close: boolean;
  @Input() isModal: boolean;
  @Output() openComponent: EventEmitter<any> = new EventEmitter();
  public pdfSrc: any;
  public lodePdf: any;
  public agxPdf: any;
  public patriotActPdf: any;
  public isDesktopMode: any;
  public agreementForm: FormGroup;
  private secondLoadingModal;
  public loadingAccept: boolean = false;
  private fileTransfer: FileTransferObject;
  //User agreements from auth service are only updated via login, it needs to be refactored into a separate check.
  private confirmedAgreements: boolean;
  options: InAppBrowserOptions = {
    location: 'yes', // Or 'no' 
    hidden: 'no', // Or  'yes'
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes', // Android only ,shows browser zoom controls 
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no', // Android only 
    closebuttoncaption: 'Close', // iOS only
    toolbar: 'yes', // iOS only 
    toolbarposition: 'top', // iOS only 
    enableViewportScale: 'no', // iOS only 
    allowInlineMediaPlayback: 'no', // iOS only 
    presentationstyle: 'fullscreen', // iOS only 
    fullscreen: 'yes', // Windows only    
  };

  constructor(
    protected store: Store<AppState>,
    private sanitizer: DomSanitizer,
    private nav: NavController,
    private formBuilder: FormBuilder,
    private appMode: AppModeService,
    private membersPortalService: MembersPortalService,
    private loadingController: LoadingController,
    private translate: TranslateService,
    private transfer: FileTransfer,
    private file: File,
    private document: DocumentViewer,
    private platform: Platform,
    private DocOpService: DocOperationsService,
    private authService: AuthService,
    private alertController: AlertController,
    private inappbrowser: InAppBrowser
  ) {
    super(store);
    this.agreementForm = this.formBuilder.group({
      term_condition: [false, [
        Validators.requiredTrue
      ]],
      term_cancellation: [false, [
        Validators.requiredTrue
      ]],
      term_privacy_policy: [false, [
        Validators.requiredTrue
      ]],
    });
  }

  async ngOnInit() {
    this.clearForm();
    this.subscriptions.add(this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode));
    this.lodePdf = `${this.tos.lang}_lode_token_contract_v${this.tos.version}`;
    this.agxPdf = `${this.tos.lang}_${this.tos.name}_v${this.tos.version}`;
    this.patriotActPdf = `${this.tos.name}`;
    let fileName = await this.getPdfName(this.tos);
    this.pdfSrc = `https://lode.one/${fileName}#navpanes=0&scrollbar=0`;
  }

  // get agreement status
  updateAgreementStatus(agreement: any) {
    const checkAgreement = (agreement && agreement.confirmed === 1) ? true : false;
    this.agreementForm.patchValue({
      term_condition: this.confirmedAgreements || checkAgreement,
      term_cancellation: this.confirmedAgreements ||checkAgreement,
      term_privacy_policy: this.confirmedAgreements ||checkAgreement,
    });
  }

  clearForm() {
    this.agreementForm.reset();
  }

  async getAgreementStatus(agreementName: string) {
    try {
    const agreements = await this.authService.getUserAgreement();
    const agreement = agreements && agreements.find(agreement => agreement.name === agreementName);
    return agreement;
    } catch (error) {
      Logger.error('getAgreementStatus',inspect(error))
    }
  }

  async getPdfName(tos) {
    let fileName = "";
    Logger.info('getPdfName',tos);
    switch (tos.name) {
      case 'agx_tos':
        fileName = this.agxPdf;
        const agxagreement = await this.getAgreementStatus(tos.name);
        this.updateAgreementStatus(agxagreement); 
        break;
      case 'lode_tos':
        fileName = this.lodePdf;
        const lodeagreement = await this.getAgreementStatus(tos.name);
        this.updateAgreementStatus(lodeagreement); 
        break;
      case 'patriot_act':
        fileName = this.patriotActPdf;
        const patriotagreement = await this.getAgreementStatus(tos.name);
        this.updateAgreementStatus(patriotagreement);
        break;
      default:
        fileName = this.lodePdf
        break;
    }
    return fileName;
  }

  getPdfUrl() {
    return this.pdfSrc;
  }

  onMoreInfo() {
    window.open('https://www.youtube.com/watch?v=6n3wpZlYzfo&feature=youtu.be', '_blank');
  }

  async handleSubmitClick() {
    this.loadingAccept = true;
    if(this.isModal){
      this.secondLoadingModal = await this.alertController.create({
        cssClass: 'light-font-alert',
        header: await this.translate.get('buy_agx.loading.please_wait').toPromise()
      });
      await this.secondLoadingModal.present();
    }else {
      this.secondLoadingModal = await this.loadingController.create({
        message: await this.translate.get('buy_agx.loading.please_wait').toPromise(),
        duration: 999999,
        cssClass: 'index-top'
      });
      await this.secondLoadingModal.present();
    }
    const res = await this.membersPortalService.updateAgreements(this.tos.id);
    this.confirmedAgreements = true;
    this.loadingAccept = false;
    this.onCancel();
    if(this.isModal){
      await this.secondLoadingModal.dismiss();
    }else {
      await this.secondLoadingModal.dismiss();
    }

    if (res && res.confirmed) {
      await presentAlert(this.alertController, this.translate, null, 'settings.tos.alert_heading', 'settings.tos.alert_success', 'settings.tos.alert_ok');
      const agreement = await this.getAgreementStatus(this.tos.name);
      this.updateAgreementStatus(agreement); 
    }
  }

  onCancel() {
    this.openComponent.emit(false);
  }

  navigateToURL(url: string): void {
    window.open(url, '_blank');
  }

  public downloadPdf(fileName) {
    if (this.platform.is('ios')) {
      try {
        this.fileTransfer = this.transfer.create();
        this.fileTransfer.download(this.pdfSrc, this.file.dataDirectory + fileName, true).then(async (entry) => {
          const url = entry.toURL();
          this.document.viewDocument(url, 'application/pdf', {});
          Logger.info('DOWNLOAD COMPLETE: ' + url);
        });
      } catch (error) {
        this.platform.ready().then(() => {
          this.inappbrowser.create(
            this.pdfSrc,
            '_system',
            this.options
          );
        });
      }
    }
    else {
      this.platform.ready().then(() => {
        this.inappbrowser.create(
          this.pdfSrc,
          '_system',
          this.options
        );
      });
    }
  }

  openUrl() {
    this.platform.ready().then(() => {
      this.inappbrowser.create(
        'https://lode.one/wp-content/uploads/2022/03/LODE-Switzerland-AG-Privacy-Policy-Feburary-2022.pdf',
        '_system',
        this.options
      );
    });
  }
}
